export default class AbstractSegment {
    constructor(provider, start, end, parent, index) {
        this.provider = provider;
        this.start = start;
        this.end = end;
        this.parent = parent;
        this.index = index;
    }

    get type() {
        throw new Error('Not implemented');
    }

    display(g) {
        throw new Error('Not implemented');
    }

    displayHighlight(ctx) {
        throw new Error('Not implemented');
    }

    displayHover(g) {
        throw new Error('Not implemented');
    }

    hovered(viewX, viewY, tolerance) {
        throw new Error('Not implemented');
    }

    length() {
        throw new Error('Not implemented');
    }

    midpoint() {
        return {
            absX: (this.start.absX + this.end.absX) / 2,
            absY: (this.start.absY + this.end.absY) / 2,
        };
    }

    export(dx, dy) {
        throw new Error('Not implemented');
    }

    exportStart(dx, dy) {
        return [this.start.absX + dx, this.start.absY + dy];
    }

    exportClosing() {
        return null;
    }

    getControlPoints() {
        return [];
    }

    samplePoints(n) {
        return [{ x: this.end.absX, y: this.end.absY }];
    }
}
